<template>
	<div id="pageRoot">
		<p id="title" class="textBase pageElement">
			¿QUIÉN LO DIJO?
		</p>

		<span class="pageInstruction" style="left: 25px; top: 125px;">
			<p>Lee los globos.</p>
		</span>
		<span class="pageInstruction" style="left: 25px; top: 172.58px;">
			<p>Dibuja los personajes y<br>
			escribe quién lo dijo.</p>
		</span>

		<p style="left: 504px; top: 20px;" class="page-tag-blind pageElement">
			Los vecinos del barrio
		</p>
		<p style="left: 834px; top: 20px;" class="page-tag-blind pageElement">
			Los chicos
		</p>
		<p style="left: 550px; top: 110px;" class="page-tag-blind pageElement">
			Venancio
		</p>
		<p style="left: 728px; top: 110px;" class="page-tag-blind pageElement">
			Don Fito
		</p>

		<span id="textBox01" class="hover-animation-a">
			<span>
				<p class="textBase">
					¡Hop, Venancio!
				</p>
			</span>
		</span>

		<uploaded-image class="image01 pageElement picture-slot-blind" v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></uploaded-image>
		<div style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 textColor="#FFFF00"></image-upload>
		</div>

		<uploaded-image class="image02 pageElement picture-slot-blind" v-bind:page="$parent.page" v-bind:type="$parent.type" number=2></uploaded-image>
		<div style="position: absolute; margin-left: 52%; margin-top: 45.3%;">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 textColor="#FFFF00"></image-upload>
		</div>

		<span id="cursiva01" class="pageElement"></span>
		<p id="text01" class="pageElement textBase">Estas letras te pueden ser útiles:</p>
		<span id="cursiva02" class="pageElement"></span>

		<span class="footer-page footer-write"></span>
	</div>
</template>
<style scoped>
#title
{
position: absolute;
width: 426px;
height: 72px;
left: 15px;
top: 28px;

font-weight: bold;
font-size: 48px;
line-height: 65px;
display: flex;
align-items: center;

color: #FFFF00;
}
#text01
{
position: absolute;
left: 51.37%;
right: 13.18%;
top: 80.99%;
bottom: 14.19%;

font-weight: normal;
font-size: 24px;
line-height: 33px;

color: #FFFF00;
}
#textBox01
{
position: absolute;
width: 400px;
height: 170.02px;
left: 72px;
top: 263px;
background-image: url(/pages/img/bajaVision/svgPage71TextBox.svg);
vertical-align: middle;
align-items: center;
z-index: 5;
}
#textBox01 span
{
position: absolute;
width: 400px;
height: 117px;
left: 0px;
top: 0px;
}
#textBox01 span p
{
width: 400px;

font-weight: normal;
font-size: 36px;
line-height: 40px;
position: absolute;
top: 50%;
transform: translateY(-50%);
color: #FFFF00;
text-align: center;
}
#cursiva01
{
position: absolute;
width: 394.32px;
height: 38.91px;
left: 529px;
top: 569px;
background-image: url(/pages/img/bajaVision/svgPage71Cursiva01.svg);
}
#cursiva02
{
position: absolute;
width: 236px;
height: 46.41px;
left: 528px;
top: 674px;
background-image: url(/pages/img/bajaVision/svgPage71Cursiva02.svg);
}
.image01{
position: absolute;
width: 462px;
height: 305px;
left: 24px;
top: 429px;
}
.image02{
position: absolute;
width: 462px;
height: 305px;
left: 527px;
top: 228px;
}
</style>

<script>
	import ImageUpload from '../../../components/ImageUpload.vue'
	export default 
	{
		name: 'App',
		components:
		{
			ImageUpload
		}
	}
</script>